<template>
    <div>
        <iModal
                :title="ModalTitle"
                v-model="showModal"
                class-name="vertical-center-modal"
                width="600px"
                :mask-closable="false"
                @on-cancel="cancel"
        >
            <div class="admin-add">
                <div class="admin-add-content">
                    <Form
                            ref="formInline"
                            :model="formInline"
                            :rules="ruleInline"
                            label-position="right"
                            :label-width="100"
                            @submit.native.prevent
                    >
                        <Row>
                            <Col span="12">
                                <FormItem label="联系人：" prop="Name">
                                    <Input type="text" v-model="formInline.Name" placeholder="请输入联系人姓名" />
                                </FormItem>
                            </Col>
                            <Col span="12">
                                <FormItem label="联系电话：" prop="Mob">
                                    <Input type="text" v-model="formInline.Mob" placeholder="请输入联系人电话" />
                                </FormItem>
                            </Col>
                        </Row>
                        <FormItem label="邮寄地址：" style="margin-bottom:0;">
                            <Row>
                                <Col span="14" >
                                    <FormItem >
                                        <Input type="text" v-model="formInline.Addr" placeholder="请输入详细邮寄地址" />
                                    </FormItem>
                                </Col>
                                <Col span="9" offset="1">
                                    <FormItem >
                                        <Input type="text" v-model="formInline.Code" placeholder="请输入邮政编码" />
                                    </FormItem>
                                </Col>
                            </Row>
                        </FormItem>
                        <Row>
                            <Col span="12">
                                <FormItem label="车牌号：">
                                    <Input type="text" v-model="formInline.CarNum" placeholder="请输入车牌号" />
                                </FormItem>
                            </Col>
                            <Col span="12">
                                <FormItem label="车辆吨位：" >
                                    <Input type="text" v-model="formInline.Carweight" placeholder="请输入车辆吨位">
                                        <span slot="append">吨</span>
                                    </Input>
                                </FormItem>
                            </Col>
                        </Row>
                        <FormItem label="抵达时间：">
                            <DatePicker type="date" placeholder="请输入抵达时间" v-model="formInline.Time" style="width:100%"></DatePicker>
                        </FormItem>
                        <Row>
                            <Col span="12">
                                <FormItem label="司机姓名：">
                                    <Input type="text" v-model="formInline.CarName" placeholder="请输入司机姓名" />
                                </FormItem>
                            </Col>
                            <Col span="12">
                                <FormItem label="司机电话：">
                                    <Input type="text" v-model="formInline.CarMob" placeholder="请输入司机手机号码" />
                                </FormItem>
                            </Col>
                        </Row>
                        <FormItem label="申请数量：" prop="applyNumber">
                            <InputNumber :max="9999" :min="1" v-model="formInline.applyNumber"></InputNumber>
                        </FormItem>
                        <FormItem label="备注：">
                            <Input v-model="formInline.Remarks" type="textarea" :rows="4"></Input>
                        </FormItem>
                    </Form>
                </div>
            </div>
            <div slot="footer">
                <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">确定</Button>
                <Button @click="cancel">取消</Button>
            </div>
        </iModal>
    </div>
</template>

<script>
    import { validator } from "@/other/validator";
    import {  mapGetters } from "vuex";

    export default {
        // 新增人员modal
        name: "addCar",
        props: {
            show: {
                type: Boolean,
                default: false
            },
            ModalTitle:{
                type: String,
            },
            options:{
                type:Object,
            }
        },
        data() {
            return {
                loading: false,
                showModal: false,
                formInline: {
                    // form双向绑定
                    Name: "", // 姓名
                    Mob: "", // 手机
                    Addr: "", // 地址
                    Code: "", // 邮编
                    CarNum: "", // 车牌号
                    Carweight: "", //车辆吨位
                    Time: "", // 时间
                    CarName:"", // 司机姓名
                    CarMob: "", // 司机手机
                    Remarks: "", // 备注
                    applyNumber: 1, // 备注
                },
                editId:'', // 编辑的id
                ruleInline: {
                    // 效验规则
                    Name: [
                        {
                            required: true,
                            message: "用户为必填选项",
                            trigger: "blur"
                        }
                    ],
                    Mob: validator.phone,
                }
            };
        },
        watch: {
            show(val, oldVal) {
                this.showModal = val;
                if (!val) this.$emit("close");
            },
            options(val){
                console.log(val,'options')
                if(val.msg){
                    this.formInline.Name = val.msg.contactName;
                    this.formInline.Mob = val.msg.contactPhone;
                    this.formInline.Addr = val.msg.address;
                    this.formInline.Code = val.msg.postcode;
                    this.formInline.CarNum = val.msg.number;
                    this.formInline.Carweight = val.msg.tonnage;
                    this.formInline.Time = val.msg.arrivalTime;
                    this.formInline.CarName = val.msg.driverName;
                    this.formInline.CarMob = val.msg.driverPhone;
                    this.formInline.applyNumber = val.msg.applyNumber || 1;
                    this.editId = val.msg.id;
                }
            }
        },
        computed: {
            ...mapGetters({
                company: "loginModule/getCompany",
                exhibition: "loginModule/getExhibition",
                joinInfo:'loginModule/getJoinInfo'
            }),
            exhibitonId() { return this.exhibition.id},
            header() { return this.$store.state.header},
        },
        methods: {
            async handleSubmit(name) {
                let form = this.formInline;
                let valid = await this.validForm(name);
                if (!valid) return;
                this.loading = true;

                // 编辑模式
                if(this.options.model){
                    this.editCar(form);
                }
                // setTimeout(c => {
                //   this.loading = false;
                // }, 5000);
                // if (!userId) {
                //   let user = await this.registerExhibition(req).catch(err => {
                //     this.loading = false;
                //   });
                //   if (!user) {
                //     userId = user.id;
                //     this.loading = false;
                //     this.$Message.error("添加失败，请重新尝试");
                //     return;
                //   }
                // }
                // let req2 = {
                //   AgentId: this.company.agentId,
                //   CompId: this.company.id,
                //   UserId: userId,
                //   RoleId: Number(form.roleId),
                //   Name: form.name,
                //   JobTitle: form.JobTitle,
                //   // Mob: form.PhoneNumber,
                //   Mob: form.mobile,
                //   IsShow: form.isShow,
                //   ShowIndex: form.showindex
                // };
                // let bool = await this.addStaff(req2).catch(err => {
                //   this.loading = false;
                // });
                // if (!bool) {
                //   this.loading = false;
                //   this.$Message.error("添加失败，请重新尝试");
                // } else if (!bool.successed) {
                //   this.loading = false;
                //   this.$Message.error("该手机号已绑定其他账号，请更换手机号");
                // } else {
                //   this.$emit('finish');
                //   this.$Message.success("添加成功！");
                //   this.cancel();
                // }
            },
            validForm(name) {
                // 验证表单
                return new Promise((resolve, reject) => {
                    this.$refs[name].validate(valid => {
                        resolve(valid);
                    });
                });
            },
            editCar(form){
                let body = {
                    "Id":this.editId,
                    "CommandId":2,
                    "SetValues": {
                            "Number": form.CarNum,
                            "Tonnage": form.Carweight,
                            "ArrivalTime": form.Time,
                            "DriverName": form.CarName,
                            "DriverPhone": form.CarMob,
                            "ContactName": form.Name,
                            "ContactPhone": form.Mob,
                            "Address": form.Addr,
                            "Postcode": form.Code,
                            "ApplyNumber": form.applyNumber,
                            "Remark": form.Remarks
                        }

                }
                this.$http.put('/api/Vehicle/PutForce',body,this.header)
                    .then( res =>{
                        console.log(res,'res')
                        if(res.status === 200 && res.data.successed){
                            this.loading = false;
                            this.$Message.success("修改成功！");
                            this.cancel();
                            // this.$emit('addFinsh');
                        }else{
                            this.loading = false;
                            this.$Message.error("修改失败，请重新尝试");
                        }
                    })
            },
            cancel() {
                this.$refs["formInline"].resetFields();
                this.formInline={
                    Name: "", // 姓名
                    Mob: "", // 手机
                    Addr: "", // 地址
                    Code: "", // 邮编
                    CarNum: "", // 车牌号
                    Carweight: "", //车辆吨位
                    Time: "", // 时间
                    CarName:"", // 司机姓名
                    CarMob: "", // 司机手机
                    Remarks: "", // 备注
                    applyNumber: 1
                };
                this.editId = '';
                this.$emit("close");
            }
        }
    };
</script>

<style scoped lang="scss">
    .admin-add {
        &-content {
            padding: 20px 40px 20px 20px;
        }
    }
    .admin-add {
        &-title {
            width: 100%;
            text-align: center;
            margin-bottom: 20px;
            font-size: 16px;
        }
        &-content {
            .submit {
                display: flex;
                justify-content: center;
                button {
                    margin-left: -75px;
                }
            }
            img {
                width: 150px;
                height: 150px;
            }
        }
        .form-code-item {
            position: relative;
            .form-code-btn {
                position: absolute;
                right: 1px;
                width: 96px;
                top: 2px;
                border: none;
                outline: none;
                &:focus {
                    box-shadow: none;
                    border: none;
                    outline: none;
                }
            }
        }
    }
</style>

